import { axiosPath, globalAxios, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    orderCountEachProvince: [],
    order_list_0: [],
    order_list_1: [],
    order_list_2: [],
    order_list_3: [],
    order_list_4: [],
    order_list_5: [],
    order_list_6: [],
    order_list_7: [],
    order_count: {},
    order_count_old: {},
    order_status_id: 1,
    order_wesmart_list_1: [],
    order_wesmart_list_2: [],
    order_wesmart_list_3: [],
    order_wesmart_list_4: [],
    order_wesmart_list_0: [],
    smallOrderDifferenceList: [],
    auto_Order: {},
    updateAutoOrder: {},
  },
  mutations: {
    setOrderCountEachProvince(state, list) {
      state.orderCountEachProvince = list;
    },
    updateOrder(state) {
      state.order_count_old.order_changed = 1;
    },
    getOldCountOrder(state, data) {
      state.order_count_old = data;
    },
    getOrderList(state, send_data) {
      let arr_sort = send_data.res_data.sort(function (a, b) {
        return new Date(a.order_time_start) - new Date(b.order_time_start);
      });
      state["order_list_" + send_data.order_status_id] = arr_sort;
    },
    getCountOrder(state, data) {
      state.order_count = data;
    },
    setOrderStatusID(state, ID) {
      state.order_status_id = ID;
    },
    cancelOrder(state, order_id) {
      for (let index = 0; index < 8; index++) {
        for (let val of state["order_list_" + index]) {
          let key = state["order_list_" + index].indexOf(val);
          if (val.order_id == order_id && index != -1) {
            state["order_list_" + index].splice(key, 1);
          }
        }
      }
    },
    changeStatus(state, data) {
      if (
        state.order_status_id != data.order_status &&
        state.order_status_id != 0
      ) {
        let index = state["order_list_" + state.order_status_id].findIndex(
          (val) => val.order_id == data.order_id
        );
        state["order_list_" + state.order_status_id].splice(index, 1);
      }
    },
    setOrderWesmartList(state, { data, status }) {
      state["order_wesmart_list_" + status] = data;
    },
    cancelOrderWesmartInStatus(state, { status, code }) {
      let index = state["order_wesmart_list_" + status].findIndex(
        (val) => val.orders_code == code
      );
      state["order_wesmart_list_" + status].splice(index, 1);
    },
    setSmallOrderList(state, list) {
      state.smallOrderDifferenceList = list;
    },
    addSmallOrderList(state, data) {
      state.smallOrderDifferenceList.push(data);
    },
    editSmallOrderList(state, data) {
      let index = state.smallOrderDifferenceList.findIndex(
        (val) => val.sod_id == data.sod_id
      );
      state.smallOrderDifferenceList.splice(index, 1, data);
    },
    deleteSmallOrder(state, sodId) {
      let index = state.smallOrderDifferenceList.findIndex(
        (val) => val.sod_id == sodId
      );
      state.smallOrderDifferenceList.splice(index, 1);
    },
    setAutoOrder(state, data) {
      state.auto_Order = data;
    },
    SetupdateAutoOrder(state, data) {
      state.updateAutoOrder = data;
    },
  },
  actions: {
    async cancelOrder({ commit, rootState, dispatch }, { order_id, order_note }) {
      let url = rootState.api_urls.fetchOrderListBack_cancelOrder + order_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: { order_note } },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        if (rootState.fetchOrderListBack.order_status_id != 0) {
          commit("cancelOrder", order_id);
        }
        return 2;
      }
    },
    async changeStatusME({ commit, rootState, dispatch }, item) {
      let url =
        rootState.api_urls.chantStatusOrderMEFront +
        item.item.order_id +
        "/status/" +
        item.status;

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      };
      let data = {};

      return axiosPath
        .post(url, {}, axiosConfig)
        .then((res) => {
          if (res.data.msg == 0 || res.data.msg == 1) {
            dispatch("checkMessage", res.data.msg, { root: true });
          }

          commit("changeStatus", res.data);
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
        });
    },
    async changeStatus({ commit, rootState, dispatch }, send_data) {
      let url =
        rootState.api_urls.chantStatusOrderFront +
        send_data.item.order_id +
        "/status/" +
        send_data.status;

      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      };
      let data = {};

      return axiosPath
        .put(url, data, axiosConfig)
        .then((res) => {
          if (res.data.msg == 0 || res.data.msg == 1) {
            dispatch("checkMessage", res.data.msg, { root: true });
          }

          commit("changeStatus", res.data);
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
        });
    },
    async getCountOrder({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchOrderListBack_getCountOrder;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getCountOrder", res);
        return res;
      }
    },
    async getOrderList({ commit, dispatch, rootState }, order_status_id) {
      let url =
        rootState.api_urls.fetchOrderListBack_getOrderList + order_status_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        let send_data = {
          order_status_id,
          res_data: res,
        };
        commit("getOrderList", send_data);
      }
    },
    async fetchOrderCountEachProvince({ dispatch, commit }) {
      let url = backendVersion.version + "/OrderAmountByProvince";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("setDisconnect", false, { root: true });
        commit("setOrderCountEachProvince", res);
        return res;
      }
    },
    async fetchOrderWesmartList({ commit, dispatch, rootState }, payload) {
      let url = `/api/v1/${payload.province}/wesmart/orderlist`;
      //  status=3&date_start_end=2021-05-18,2021-06-18
      return globalAxios
        .get(url, {
          params: {
            status: payload.status,
            date_start_end: payload.date_start_end,
          },
        })
        .then((res) => {
          commit("setOrderWesmartList", {
            data: res.data,
            status: payload.status,
          });
          // console.log('print', res)
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchAutoOrder({ commit, dispatch, rootState }, payload) {
      let url = `/api/v1/weserve_for_business/${payload}/get_auto_order`;
      return globalAxios
        .get(url)
        .then((res) => {
          commit("setAutoOrder", res.data);
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchUpdateAutoOrder({ commit, dispatch, rootState }, payload) {
      let url = `/api/v1/weserve_for_business/${payload}/update_auto_order`;
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      };
      return globalAxios
        .put(url, axiosConfig)
        .then((res) => {
          commit("SetupdateAutoOrder", res.data);
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
        });
    },
    async fetchSmallOrderDifferenceList(
      { commit, dispatch, rootState },
      province
    ) {
      let url = `/api/v1/${province}/manage/small_order_difference/get_all`;
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setSmallOrderList", res.data);
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchSmallOrderDifferenceById(
      { commit, dispatch, rootState },
      { sodId, province }
    ) {
      let url = `/api/v1/${province}/manage/small_order_difference`;
      return globalAxios
        .get(url, {
          params: {
            sod_id: sodId,
          },
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async updateSmallOrderDifference(
      { commit, dispatch, rootState },
      { payload, province }
    ) {
      let url = `/api/v1/${province}/manage/small_order_difference`;
      let body = {
        sod_id: payload.sod_id,
        sod_district_id: payload.sod_district_id,
        sod_store_id: payload.sod_store_id,
        sod_status: payload.sod_status,
        sod_minimum_price: payload.sod_minimum_price,
      };

      return globalAxios
        .put(url, body)
        .then((res) => {
          commit("editSmallOrderList", res.data);
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async createSmallOrderDifference(
      { commit, dispatch, rootState },
      { payload, province }
    ) {
      let url = `/api/v1/${province}/manage/small_order_difference`;
      let body = {
        sod_district_id: payload.sod_district_id,
        sod_store_id: payload.sod_store_id,
        sod_status: payload.sod_status,
        sod_minimum_price: payload.sod_minimum_price,
      };

      return globalAxios
        .post(url, body)
        .then((res) => {
          commit("addSmallOrderList", res.data);
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async removeSmallOrderDifference(
      { commit, dispatch, rootState },
      { sodId, province }
    ) {
      let url = `/api/v1/${province}/manage/small_order_difference`;

      return globalAxios
        .delete(url, {
          params: {
            sod_id: sodId,
          },
        })
        .then((res) => {
          commit("deleteSmallOrder", sodId);
          return res.msg;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {},
};
